import { render, staticRenderFns } from "./ApplicableAreaForm.vue?vue&type=template&id=65ea5b84&scoped=true&"
import script from "./ApplicableAreaForm.vue?vue&type=script&lang=js&"
export * from "./ApplicableAreaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea5b84",
  null
  
)

export default component.exports